Object.defineProperty(exports,"__esModule",{value:true});var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _throttle2=require("lodash/throttle");var _throttle3=_interopRequireDefault(_throttle2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _victoryCore=require("victory-core");

var _react=require("react");var _react2=_interopRequireDefault(_react);
var _eventHandlers=require("../../helpers/event-handlers.js");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var SelectionHelpers={
getDatasets:function getDatasets(props){
if(props.data){
return[{data:props.data}];
}

var getData=function getData(childProps){
var data=_victoryCore.Data.getData(childProps);
return Array.isArray(data)&&data.length>0?data:undefined;
};

var iteratee=function iteratee(child,childName,parent){
if(child.type&&child.type.role==="axis"){
return null;
}else if(child.type&&(0,_isFunction3.default)(child.type.getData)){
child=parent?_react2.default.cloneElement(child,parent.props):child;
var childData=child.props&&child.type.getData(child.props);
return childData?{childName:childName,data:childData}:null;
}else{
var _childData=getData(child.props);
return _childData?{childName:childName,data:_childData}:null;
}
};
return _victoryCore.Helpers.reduceChildren(_react2.default.Children.toArray(props.children),iteratee);
},

filterDatasets:function filterDatasets(datasets,bounds){var _this=this;
var filtered=datasets.reduce(function(memo,dataset){
var selectedData=_this.getSelectedData(dataset.data,bounds);
memo=selectedData?
memo.concat({
childName:dataset.childName,eventKey:selectedData.eventKey,data:selectedData.data}):

memo;
return memo;
},[]);
return filtered.length?filtered:null;
},

getSelectedData:function getSelectedData(dataset,bounds){var
x=bounds.x,y=bounds.y;
var withinBounds=function withinBounds(d){
return d._x>=x[0]&&d._x<=x[1]&&d._y>=y[0]&&d._y<=y[1];
};
var eventKey=[];
var data=[];
var count=0;
for(var index=0,len=dataset.length;index<len;index++){
var datum=dataset[index];
if(withinBounds(datum)){
data[count]=datum;
eventKey[count]=datum.eventKey===undefined?index:datum.eventKey;
count++;
}
}
return count>0?{eventKey:eventKey,data:data}:null;
},

onMouseDown:function onMouseDown(evt,targetProps){
evt.preventDefault();var
dimension=targetProps.dimension,scale=targetProps.scale;
var datasets=targetProps.datasets||[];var _Selection$getSVGEven=
_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven.x,y=_Selection$getSVGEven.y;
var x1=dimension!=="y"?x:_victoryCore.Selection.getDomainCoordinates(scale).x[0];
var y1=dimension!=="x"?y:_victoryCore.Selection.getDomainCoordinates(scale).y[0];
var x2=dimension!=="y"?x:_victoryCore.Selection.getDomainCoordinates(scale).x[1];
var y2=dimension!=="x"?y:_victoryCore.Selection.getDomainCoordinates(scale).y[1];
if((0,_isFunction3.default)(targetProps.onSelectionCleared)){
targetProps.onSelectionCleared();
}
return[
{
target:"parent",
mutation:function mutation(){
return{x1:x1,y1:y1,select:true,x2:x2,y2:y2};
}},
{
target:"data",
childName:targetProps.children||datasets.length?"all":undefined,
eventKey:"all",
mutation:function mutation(){return null;}}];


},

onMouseMove:function onMouseMove(evt,targetProps){var
dimension=targetProps.dimension,scale=targetProps.scale,select=targetProps.select;
if(!select){
return{};
}else{var _Selection$getSVGEven2=
_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven2.x,y=_Selection$getSVGEven2.y;
var x2=dimension!=="y"?x:_victoryCore.Selection.getDomainCoordinates(scale).x[1];
var y2=dimension!=="x"?y:_victoryCore.Selection.getDomainCoordinates(scale).y[1];
return{
target:"parent",
mutation:function mutation(){
return{x2:x2,y2:y2};
}};

}
},

onMouseUp:function onMouseUp(evt,targetProps){var
x2=targetProps.x2,y2=targetProps.y2;
if(!x2||!y2){
return[{
target:"parent",
mutation:function mutation(){
return{select:false,x1:null,x2:null,y1:null,y2:null};
}}];

}
var datasets=this.getDatasets(targetProps);
var bounds=_victoryCore.Selection.getBounds(targetProps);
var selectedData=this.filterDatasets(datasets,bounds);
var callbackMutation=selectedData&&(0,_isFunction3.default)(targetProps.onSelection)?
targetProps.onSelection(selectedData,bounds):{};

var parentMutation=[{
target:"parent",
mutation:function mutation(){
return{datasets:datasets,select:false,x1:null,x2:null,y1:null,y2:null};
}}];


var dataMutation=selectedData?
selectedData.map(function(d){
return{
childName:d.childName,eventKey:d.eventKey,target:"data",
mutation:function mutation(){
return(0,_assign3.default)({active:true},callbackMutation);
}};

}):[];

return parentMutation.concat(dataMutation);
}};exports.default=


{
onMouseDown:SelectionHelpers.onMouseDown.bind(SelectionHelpers),
onMouseUp:SelectionHelpers.onMouseUp.bind(SelectionHelpers),
onMouseMove:(0,_throttle3.default)(
(0,_eventHandlers.attachId)(SelectionHelpers.onMouseMove.bind(SelectionHelpers)),
16,
{leading:true,trailing:false})};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/containers/selection-helpers.js
// module id = 675
// module chunks = 0